<template>
  <div class="block-relative">
    <router-view />
    <div v-if="loading" class="loader block__absolute flex-box" style="position:fixed">
      <div class="icon text-white flex-box">
        <i class="fas fa-spinner fa-spin" />
      </div>
    </div>

  
    <portal-target name="sidebar" multiple>
  
    </portal-target>
  </div>
</template>

<script>
import { mapState } from "vuex";

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
};

export default {
  computed: {
    ...mapState(["loading"]),
  },

  mounted() {
    console.log(this.$auth);    
  },

  
};
</script>

<style>
@font-face {
  font-family: "Gotham-Bold";
  src: local("Gotham-Bold"),
   url(./fonts/GothamBold/Gotham-Bold.otf) format("truetype");
}
</style>
